import { render, staticRenderFns } from "./aboutus_m.vue?vue&type=template&id=8199b326&scoped=true"
import script from "./aboutus_m.vue?vue&type=script&lang=js"
export * from "./aboutus_m.vue?vue&type=script&lang=js"
import style0 from "./aboutus_m.vue?vue&type=style&index=0&id=8199b326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8199b326",
  null
  
)

export default component.exports